import React from "react";
import "./index.scss";
import Loader from "../Loader";

const BtnWithLoader = ({ loading, label, ...props }) => (
  <div className="btn-wrapper">{loading ? <Loader /> : <button {...props}>{label}</button>}</div>
);

export default BtnWithLoader;
